<template>
  <div v-if="visible">
    <h3>Brugperiode</h3>
    <table class="table table-condensed">
      <tbody>
        <template v-for="row in rows">
          <tr
            v-if="rowVisible(row)"
            :key="row.title"
          >
            <th>{{ row.title }}</th>
            <td v-html="row.value" />
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    const { school } = this;
    return {
      rows: [
        {
          title: 'duur en indeling brugperiode',
          value: `${school.duur_brugperiode}
          ${school.indeling_brugperiode}`,
          show:
            isset(school.duur_brugperiode) || isset(school.indeling_brugperiode),
        },
        {
          title: 'bijzonderheden brugperiode',
          value: school.bijzonderheden_brugperiode,
        },
        {
          title: 'huiswerk',
          value: school.huiswerklast,
        },
        {
          title: 'huiswerkbegeleiding',
          value: school.huiswerkbegeleiding,
        },
        {
          title: 'studiebegeleiding',
          value: school.studiebegeleiding,
        },
      ],
    };
  },
  computed: {
    visible() {
      if (!this.rows) {
        return false;
      }
      const visibleRow = this.rows.find((row) => this.rowVisible(row));
      return isset(visibleRow);
    },
  },
  methods: {
    rowVisible(row) {
      return row.show === true || (row.show === undefined && row.value);
    },
  },
};

function isset(value) {
  return !!value;
}
</script>
